import React from 'react'
import PropTypes from 'prop-types'
import PageContainer from '../PageContainer/PageContainer'
import Note from '../Shared/Note/Note'
import IconBulletList from '../Shared/IconBulletList/IconBulletList'
import classnames from 'classnames'
import styles from './AboutYou.module.scss'

const AboutYou = (props) => {
  const primaryButtonClasses = classnames(
    'button',
    'button--primary',
    styles.submitButton,
  )

  const {
    goOnboardingPersonalInformation,
    hide,
    isLoading,
    isMobile
  } = props

  const prevPageInfo = {
    name: 'Getting Started',
    to: '/onboarding/getting_started',
    showBackWord: true
  }

  return (
    <PageContainer
      name="About You"
      isMobile={isMobile}
      prevPageInfo={prevPageInfo}
      isLoading={isLoading}
      hide={hide || isLoading}>
      <div className={styles.AboutYou}>
        <p className={styles.subDescription}>
          We already have some of your information — here’s what we still need to cover:
        </p>
        <Note className={styles.note}>
          <IconBulletList
            icon="checked"
            items={['Personal Information', 'Identity Verification', 'Employment Details']} />
        </Note>
        <button
          className={primaryButtonClasses}
          type="submit"
          onClick={goOnboardingPersonalInformation} >
            Continue
        </button>
      </div>
    </PageContainer>
  )
}

AboutYou.propTypes = {
  goOnboardingPersonalInformation: PropTypes.func.isRequired,
  hide: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
}

export default AboutYou



// WEBPACK FOOTER //
// ./src/components/Onboarding/AboutYou/AboutYou.jsx